import { useCallback, useRef } from 'react';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function useDebouncedCallback(fn: (...args: Array<any>) => void, delay?: number) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debounced = useCallback(
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    (...args: any) => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        fn.call(null, ...args);
      }, delay ?? 250);
    },
    [delay, fn],
  );

  return debounced;
}
